import { Flex, Heading, Tag } from '@applyboard/crystal-ui';
import { ProfileState } from '../../clients';

export type PageHeadingProps = {
  title: string;
  imageSrc?: string;
  imageAlt?: string;
  state?: ProfileState;
};

export function PageHeading({ title, imageSrc, imageAlt, state }: PageHeadingProps): JSX.Element {
  return (
    <Flex gap={4} align="center">
      {imageSrc && imageAlt && <img src={imageSrc} width="56px" alt={imageAlt} />}
      <Heading level={1} variant="titleL">
        {title}
      </Heading>
      {state && (
        <Tag intent={state === ProfileState.active ? 'positive' : 'negative'}>
          {state.charAt(0).toUpperCase() + state.slice(1)}
        </Tag>
      )}
    </Flex>
  );
}
